<template>
	<div id="sort_bar">
		<div id="quickFilterAndInstaSearchDiv" v-if="!$store.getters.isMobile || (!$store.getters.showMobileVehicleResults && !$store.getters.vehicleGallerySelected)">
            <instant-search/>
		</div>

        <div id="backToFiltersDiv" v-if="$store.getters.isMobile && $store.getters.showMobileVehicleResults && !$store.getters.vehicleGallerySelected" @click="backToFilters">
            &#10094;&nbsp;Filters
        </div>
        <div id="backToResultsDiv" v-if="$store.getters.isMobile && $store.getters.vehicleGallerySelected" @click="backToResults">
            &#10094;&nbsp;Back
        </div>
        
        <div id="sortOrderColumns" :class="[userAuthenticated ? 'auth' : '']" v-if="!$store.getters.isMobile">
            <div id="noSortWhileQueryRunningModal" v-if="$store.getters.isQueryRunning">
            </div>
            <div v-for="(sortCol, index) in availableSortColumns" :key="index">
               <div @click="sortBy(sortCol)" class="sortColumnHeader" :class="[isSortable(sortCol) ? 'sortable' : '']">
                    {{ $store.getters.getAvailablSortColumnByName(sortCol).display }}
                    <sort-indicator :col="sortCol" v-if="isSortable(sortCol)"/>
                </div>
            </div>
        </div>

        <div id="mobileNoSortWhileQueryRunningModal" v-if="$store.getters.isQueryRunning && $store.getters.isMobile && $store.getters.showMobileVehicleResults">
        </div>
        <div id="mobileSortOrder" :class="[userAuthenticated ? 'auth' : '']" v-if="$store.getters.isMobile && ($store.getters.showMobileVehicleResults && !$store.getters.vehicleGallerySelected)">
            <div id="selectedSortOrder" @click="showSortOptions">
                <div id="mobileDefaultDisplay" v-if="hideDeafultSortOrder" class="sortOrderColumnOption">
                    Sort By&nbsp;&#10095;
                </div>
                <div id="selectedSortOrderColumn" v-else class="sortOrderColumnOption">
                    <div class="sortColumnOrderName">
                        {{ $store.getters.getAvailablSortColumnByName(sortSelected.sort_column).display }}
                    </div>
                    <sort-indicator :col="sortSelected.sort_column" :reverse="sortSelected.sort_reverse"/>
                </div>
            </div>
            <div id="sortOptionsDropDownList" v-if="openSortOptions">
                <div v-for="(sortOption, index) in availableSortColumnsAndDirections" class="sortOrderColumnOption" :key="index" @click="selectSort(sortOption)">
                    <sort-indicator :col="sortOption.col" :reverse="sortOption.direction"/>
                    <div class="sortColumnOrderName" :class="[isActive(sortOption) ? 'highlight' : '']">
                        {{ $store.getters.getAvailablSortColumnByName(sortOption.col).display }}
                    </div>
                </div>
            </div>
        </div>
	</div>
</template>

<script>
    import SortOrderIndicator from './SortOrderIndicator.vue'
    import InstantSearch from './InstantSearch.vue'

    export default {
        data() {
            return {
                openSortOptions: false
            }
        },
        components: {
            'sort-indicator': SortOrderIndicator,
            'instant-search': InstantSearch
        },
        mounted() {
            document.addEventListener('click', this.handleClickOutsideSort);
        },
        unmounted() {
            document.removeEventListener('click', this.handleClickOutsideSort)
        },
        computed: {
            userAuthenticated() {
                return this.$store.getters.isLoggedIn;
            },
            sortSelected() {
                return { sort_column: this.$store.getters.getSortColumn, sort_reverse: this.$store.getters.getSortDirection };
            },
            availableSortColumns() {
                return this.$store.getters.getAvailablSortColumnNames;
            },
            availableSortColumnsAndDirections() {
                let sortOptions = [];

                for(var s = 0; s < this.availableSortColumns.length; s++) {
                    if(this.availableSortColumns[s] != 'BOB' || this.$store.getters.getDeafultSortCol == 'BOB') {
                        sortOptions.push({col: this.availableSortColumns[s], direction: true});
                        sortOptions.push({col: this.availableSortColumns[s], direction: false});
                    }
                }

                return sortOptions;
            },
            hideDeafultSortOrder() {
                return true;//(!this.userAuthenticated && this.$store.getters.isMobile && this.$store.getters.getSortColumn == 'BOB');
            }
        },
        methods: {
            sortBy(col) {
                let newSortCol = this.$store.getters.getAvailableSortColumns[col];
                if(newSortCol.sortable) {
                    this.$store.commit('setSortColumn', col);
                    
                    if(this.$store.getters.getSortColumn != col) {
                        this.$store.commit('setSortDirection', newSortCol.defaultDirectionDesc);
                    }
                    else {
                        this.$store.commit('setSortDirection', (!this.$store.getters.getSortDirection));
                    }

                    this.$store.commit('notifySearchQueryChanges', true);
                }
            },
            isSortable(col) {
                return this.$store.getters.getAvailableSortColumns[col].sortable;
            },
            backToFilters() {
                this.$store.commit('updateShowMobileVehicleResultsStatus', false);
            },
            backToResults() {
                this.$store.commit('setVehicleGallerySelected', null);
            },
            showSortOptions() {
                this.openSortOptions = true;
            },
            selectSort(value) {
                let eventLabel = this.$store.getters.isMobile ? 'mobile' : 'pc';
                this.$gtag.event('change', {'event_category': 'sort_order','event_label': eventLabel});
                this.$store.commit('setSortColumn', value.col);
                this.$store.commit('setSortDirection', value.direction);
                this.$store.commit('notifySearchQueryChanges', true);

                this.openSortOptions = false;
            },
            handleClickOutsideSort(evt) {
                if (!this.$el.contains(evt.target)) {
                    this.openSortOptions = false;
                }
            },
            isActive(sortOption) {
                if(this.$store.getters.isMobile) {
                    return (sortOption.col == this.$store.getters.getSortColumn && sortOption.direction == this.$store.getters.getSortDirection);
                }

                return this.col == this.$store.getters.getSortColumn;
            }
        }
    }
</script>

<style scoped>
    #sort_bar {
        width: 100%;
        height: calc(5 * var(--vh));
        font-family: arial, sans-serif;
        font-size: calc((1 * var(--vw)) + ((var(--vratio) - .5) * 1em)); /*calc(.5vw + ((1 - var(--vratio)) * 1em));*//*1.05em;*/
        font-weight: bolder;
        color: white;/*rgb(102, 102, 102);*/
        background: #2B2A2B;/*linear-gradient(rgb(255,255,255), rgb(222, 222, 222));*/
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }

    .inmobile #sort_bar {
        justify-content: space-between;
        width: calc(100 * var(--vw));
        height: calc(4 * var(--vh));
        /*font-size: .9em;*/
		font-size: calc(2.1 * var(--vh));
    }

    #quickFilterAndInstaSearchDiv {
        width: calc(22 * var(--vw));
        height: inherit;
        display: flex;
    }

    .inmobile #quickFilterAndInstaSearchDiv {
        width: 100%;
        justify-content: space-around;
        align-items: center;
        color: black;
    }

    #sortOrderColumns {
        width: calc(68 * var(--vw));
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
    }

    #sortOrderColumns.auth {
        width: calc(68 * var(--vw));
    }
    
    #noSortWhileQueryRunningModal {
        height: calc(5 * var(--vh));
        width: calc(68 * var(--vw));
        z-index: 3;
        background-color: #2B2A2B;
        opacity: .4;
        position: absolute;
        top: calc(12 * var(--vh));
        left: calc(32 * var(--vw));
    }

    .auth #noSortWhileQueryRunningModal {
        width: calc(68 * var(--vw));
        left: calc(32 * var(--vw));
    }

    #mobileSortOrder {
        position: relative;
    }

    #mobileNoSortWhileQueryRunningModal {
        width: calc(50 * var(--vw));
        height: calc(12 * var(--vh));
        top: calc(12 * var(--vh));
        left: calc(48 * var(--vw));
        z-index: 3;
        background-color: #2B2A2B;
        opacity: .4;
        position: absolute;
    }

    .auth #mobileNoSortWhileQueryRunningModal {
        width: calc(50 * var(--vw));
        left: calc(50 * var(--vw));
    }

    .sortColumnHeader {
        width: calc((68/9) * var(--vw));
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .auth .sortColumnHeader {
        width: calc((68/11) * var(--vw));
    }

    .sortable:hover {
        cursor: pointer;
        color: var(--mccluskeyGold); /*#AF873F;*/
    }

    #backToFiltersDiv {
        margin: 0 calc(2 * var(--vw));
        display: flex;
        justify-content: center;
        align-items: center;
    }

    #backToFiltersDiv:hover {
        cursor: pointer;
        color: var(--mccluskeyGold); /*#AF873F;*/
    }

    #backToResultsDiv {
        margin: 0 calc(2 * var(--vw));
    }
    
    #backToResultsDiv:hover {
        cursor: pointer;
        color: var(--mccluskeyGold); /*#AF873F;*/
    }

    #sortOptionsDropDownList {
        position: absolute;
        z-index: 4;
        width: fit-content;
        height: fit-content;
        color: white;
        background-color: #2B2A2B;
        top: calc(5.25 * var(--vh));
        right: calc(.5 * var(--vw));
    }

    .sortOrderColumnOption {
        display: flex;
        justify-content: flex-end;
        margin: calc(2 * var(--vh))
    }

    .sortColumnOrderName {
        margin: calc(1 * var(--vh));
    }

    .highlight {
        color: var(--mccluskeyGold); /*#AF873F;*/
    }
</style>
